import { queryOptions, useQuery } from '@tanstack/react-query'
import { TraceKeysApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

const traceKeyTemplatesQueryOptions = (traceKeyId: number) =>
  queryOptions({
    queryKey: queryKeys.templates(traceKeyId),
    queryFn: () =>
      baseClient.getApi(TraceKeysApi).getTraceKeyTemplates({ traceKeyId }),
  })

/**
 * 検索キーに紐づくひな形リストを取得するフック
 *
 * @param traceKeyId 検索キーID
 */
export const useQueryTraceKeyTemplates = (traceKeyId: number) =>
  useQuery({
    ...traceKeyTemplatesQueryOptions(traceKeyId),
  })
